import CardDragGame from './CardDragGame';

export default CardDragGame;
